<template>
    <div v-if="menuStore.isDesktop"
         class="grid-menu">
        <div v-for="(_, columnIndex) in COLUMN_COUNT"
             :key="columnIndex"
             class="grid-column">
            <div v-for="(columnItem, index) in getColumnItems(columnIndex)"
                 :key="index"
                 class="d-flex">
                <DataMenu :menu="columnItem" />
            </div>
        </div>
    </div>
    <div v-else
         class="grid-menu">
        <DataMenu v-for="(childMenu, index) in menu.children"
                  :key="index"
                  :menu="childMenu" />
    </div>
</template>

<script setup lang="ts">
    import DataMenu from '../menus/DataMenu.vue';
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import { INavigationGrid } from '../types/menuTypes';

    const props = defineProps<{ menu: INavigationGrid }>();

    const menuStore = useMenuStore();

    const COLUMN_COUNT = menuStore.isDesktop ? 2 : 1;

    const getColumnItems = (columnIndex) => {
        const start = columnIndex * (props.menu.children.length / COLUMN_COUNT);
        const end = (columnIndex + 1) * (props.menu.children.length / COLUMN_COUNT);

        return props.menu.children.slice(start, end);
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.grid-menu {
    display: grid;
    gap: legacyVariables.$menu-container-gap;
    grid-template-columns: repeat(v-bind(COLUMN_COUNT), 1fr);

    .grid-column {
        display: grid;
        gap: legacyVariables.$menu-container-gap;
    }
}

.mobile-nav {
    .grid-column,
    .grid-menu {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
    }
}
</style>
